import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconAngry$1 = /*@__PURE__*/ proxyCustomElement(class WppIconAngry extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-angry", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M10 2.00488C14.4183 2.00488 18 5.5866 18 10.0049C18 14.4232 14.4183 18.0049 10 18.0049C5.58172 18.0049 2 14.4232 2 10.0049C2 5.5866 5.58172 2.00488 10 2.00488ZM10 3.20488C6.24446 3.20488 3.2 6.24935 3.2 10.0049C3.2 13.7604 6.24446 16.8049 10 16.8049C13.7555 16.8049 16.8 13.7604 16.8 10.0049C16.8 6.24935 13.7555 3.20488 10 3.20488ZM10 11.1996C11.305 11.1996 12.5283 11.7235 13.4248 12.6359C13.6571 12.8723 13.6538 13.2522 13.4174 13.4844C13.181 13.7167 12.8011 13.7133 12.5689 13.477C11.8957 12.7919 10.9798 12.3996 10 12.3996C9.01809 12.3996 8.10028 12.7936 7.42678 13.4814C7.19494 13.7181 6.81506 13.7221 6.5783 13.4903C6.34154 13.2584 6.33756 12.8786 6.5694 12.6418C7.46637 11.7258 8.69212 11.1996 10 11.1996ZM6.13148 5.82637C6.31967 5.59113 6.64882 5.53508 6.90152 5.68235L6.97482 5.73266L8.97482 7.33266C9.23357 7.53967 9.27553 7.91724 9.06852 8.176C8.95005 8.32409 8.77572 8.40116 8.59976 8.40121C8.59979 8.95351 8.15233 9.40097 7.60036 9.40097C7.04839 9.40097 6.60093 8.95351 6.60093 8.40154C6.60093 7.9806 6.86116 7.62045 7.22952 7.47317L6.22518 6.6697C5.96643 6.4627 5.92447 6.08512 6.13148 5.82637ZM11.026 7.33275L13.0251 5.73275C13.2838 5.52568 13.6614 5.56755 13.8684 5.82626C14.0567 6.06145 14.0392 6.39489 13.8401 6.60914L13.7749 6.66962L12.7706 7.47292C13.1393 7.62004 13.3998 7.98036 13.3998 8.40154C13.3998 8.95351 12.9523 9.40097 12.4004 9.40097C11.8829 9.40097 11.4573 9.0077 11.4061 8.50373L11.4009 8.39991C11.2253 8.4012 11.051 8.32416 10.9325 8.17611C10.7443 7.94092 10.7617 7.60748 10.9608 7.39323L11.026 7.33275L13.0251 5.73275L11.026 7.33275Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-angry-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-angry", "wpp-icon-angry-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-angry-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-angry-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconAngry$1);
      }
      break;
  } });
}

const WppIconAngry = WppIconAngry$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconAngry, defineCustomElement };
